module.exports = __webpack_public_path__ + "img/barcode-scanner.b983d380.svg";